import React from 'react';
import classNames from 'classnames';
import { makeStyles } from 'design-system/styles';
import { Paper } from 'design-system/Paper';

import Attachment from 'react-scale/components/scalers/common/task-attachment/index';
import SanitizedMarkdown from 'design-system/SanitizedMarkdown';
import ProtectedTextAttachment from 'react-scale/components/scalers/tasks/textcollection/ProtectedTextAttachment';
import {
  NerAttachment,
  NerAttachmentType,
} from '@scale/shared/types/params/namedentityrecognition';

interface AttachmentViewProps {
  attachment: NerAttachment;
  hidden?: boolean; // note: is always false for now
  stacked?: boolean; // note: is always true for now
  loggedUserId?: string;
  useProtectedText?: boolean;
  handleLinkClickHistory?: (link: string) => void;
}

const noop = () => {};

export default function AttachmentView(props: AttachmentViewProps) {
  const styles = useAttachmentViewStyles();

  const renderType = () => {
    switch (props.attachment.type) {
      case NerAttachmentType.Text:
        return (
          <Paper className={styles.textAttachment}>
            {props.useProtectedText ? (
              <ProtectedTextAttachment
                text={props.attachment.content}
                loggedUserId={props.loggedUserId}
              />
            ) : (
              <SanitizedMarkdown
                text={props.attachment.content}
                handleLinkClickHistory={props.handleLinkClickHistory}
              />
            )}
          </Paper>
        );
      default:
        return (
          <Attachment
            attachmentType={props.attachment.type}
            attachment={props.attachment.content}
            onLoadOrError={noop}
          />
        );
    }
  };
  return (
    <div
      className={classNames(styles.attachment, {
        [styles.fixed]: !props.stacked,
        [styles.hidden]: props.hidden,
      })}
    >
      {renderType()}
    </div>
  );
}

const useAttachmentViewStyles = makeStyles({
  attachment: {
    width: '100%',
  },
  fixed: {
    height: '100%',
    overflowY: 'scroll',
  },
  hidden: {
    display: 'none',
  },
  textAttachment: {
    margin: 24,
    padding: '18px 24px 18px 24px',
    lineHeight: 1.6,
    '& tr': {
      border: '1px solid rgba(0, 0, 0, 0.3)',
    },
    '& tr:nth-child(even)': {
      backgroundColor: '#f2f2f2',
    },
    '& th': {
      border: '1px solid rgb(0, 0, 0, 0.3)',
      padding: '6px 10px',
      backgroundColor: '#f2f2f2',
    },
    '& td': {
      border: '1px solid rgba(0, 0, 0, 0.3)',
      padding: '10px',
    },
    position: 'relative',
  },
});
